import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: {
      type: String,
      defaultValue: () => "/app/customers/:id",
    },
  };

  static targets = [
    "select",
    "template",
    "container",
    "preview",
    "selectContainer",
  ];

  connect() {
    const observer = new MutationObserver(() => {
      const hasContent = this.previewTarget.innerHTML.trim().length > 0;
      this.selectContainerTarget.style.display = hasContent ? "none" : "block";
    });

    observer.observe(this.previewTarget, { childList: true, subtree: true });

    if (this.selectTarget.value.trim().length > 0) {
      this.fetch({ target: this.selectTarget });
    }
  }

  fetch({ target }) {
    const url = this.urlValue.replace(":id", target.value);

    get(url, {
      responseKind: "turbo-stream",
    });
  }

  reset() {
    this.previewTarget.innerHTML = "";
    this.selectContainerTarget.innerHTML = this.templateTarget.innerHTML;
  }
}
